import type { Namespace, TFunction } from 'i18next';

import type { ApiResponse } from '../models/ApiResponse';

export const apiErrorMessage = (
  meta: ApiResponse<unknown>['meta'] | undefined,
  t: TFunction<Namespace>,
  currentUserName: string | null | undefined,
): string | undefined => {
  if (!meta?.errorKey || !meta.errorArgs?.length || !currentUserName) return meta?.message;

  const key = `errors.api.${meta.errorKey}`;
  // a group key returns an object; a missing key returns the key
  const text: unknown = t(key, {
    returnObjects: true,
    currentUserName,
    ...Object.fromEntries(meta.errorArgs.map((a, i) => [i, a])),
  });
  return typeof text === 'string' && text !== key ? text : meta.message;
};
